import { render, staticRenderFns } from "./AdminTemplateList.vue?vue&type=template&id=eb45a632&scoped=true&"
import script from "./AdminTemplateList.vue?vue&type=script&lang=js&"
export * from "./AdminTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./AdminTemplateList.vue?vue&type=style&index=0&id=eb45a632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb45a632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb45a632')) {
      api.createRecord('eb45a632', component.options)
    } else {
      api.reload('eb45a632', component.options)
    }
    module.hot.accept("./AdminTemplateList.vue?vue&type=template&id=eb45a632&scoped=true&", function () {
      api.rerender('eb45a632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminTemplateList.vue"
export default component.exports